<template>
  <div class="row">
    <!-- 搜尋列 -->
    <div class="col-12 mb-3" v-if="showSearchBar">
      <b-form-input v-model="search_query" :placeholder="$t('lendable-book.search-bar.placeholder')" class="w-100" />
    </div>
    <!-- 可借閱書籍卡片列表 -->
    <div class="col-md-6 col-12 mb-3" v-for="(book, index) in filtered_books" :key="book.id">
      <b-card no-body class="overflow-hidden">
        <b-card-body class="d-flex flex-column justify-content-between">
          <b-card-text>
            <!-- 書名 -->
            <h5 class="text-primary font-weight-bold">{{ book.title }}</h5>
            <!-- 作者 -->
            <p class="text-muted mb-2" v-if="book.author">
              <small>{{ book.author }}</small>
            </p>
            <!-- 關鍵借閱欄位資訊 -->
            <div class="small text-dark">
              <div>
                <strong>{{ $t('lendable-book.list.label.registration-number') }}：</strong>{{ book.registration_number }}
              </div>
              <div v-if="book.call_number">
                <strong>{{ $t('lendable-book.list.label.call-number') }}：</strong>{{ book.call_number }}
              </div>
            </div>
          </b-card-text>
          
          <!-- 按鈕區 -->
          <b-button-toolbar class="mt-3">
            <b-button-group>
              <b-button variant="outline-primary" @click="showInfo(book)">
                {{ $t('lendable-book.list.button.introduction.label') }}
              </b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-card-body>
      </b-card>
    </div>
    
    <!-- 詳細資訊彈窗 Modal -->
    <b-modal :id="`lendable-book-info-${uuid}`" :title="$t('lendable-book.detail.title')" scrollable centered size="lg">
      <lendable-book-info :book="selected_book" v-if="selected_book"></lendable-book-info>
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="secondary" @click="close()">
          {{ $t('modal.button.close.label') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import UUID from '@estudioliver/vue-uuid-v4'
import { CardPlugin, ModalPlugin, ButtonPlugin, ButtonGroupPlugin, ButtonToolbarPlugin, FormInputPlugin } from 'bootstrap-vue'
import LendableBookInfo from '@/components/info/LendableBookInfo.vue'
import i18n from '@/plugins/i18n.js'

Vue.use(CardPlugin)
Vue.use(ModalPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(FormInputPlugin)
Vue.use(UUID)

/**
 * 可借閱經典卡片列表組件 (Lendable Book Card List)
 */
export default {
  i18n,
  name: 'lendable-book-card-list',
  props: {
    // 可借閱經典資料陣列
    books: {
      type: Array,
      required: true
    },
    showSearchBar: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      uuid: null,
      selected_book: null, // 當前選中以展示詳細資料的書籍物件
      search_query: '' // 搜尋關鍵字
    }
  },
  computed: {
    filtered_books() {
      if (!this.search_query) return this.books;
      const q = this.search_query.toLowerCase();
      return this.books.filter(book => {
        const title = (book.title || '').toString().toLowerCase();
        const author = (book.author || '').toString().toLowerCase();
        return title.includes(q) || author.includes(q);
      });
    }
  },
  methods: {
    /**
     * 開啟 Modal 並展示書籍詳細資料
     * @param {Object} book - 選中的書籍物件
     */
    showInfo(book) {
      this.selected_book = book
      this.$bvModal.show(`lendable-book-info-${this.uuid}`)
    }
  },
  created() {
    // 產生唯一的元件 uuid 以避免多個列表時 Modal ID 衝突
    this.uuid = this.$uuidKey()
  },
  components: {
    LendableBookInfo
  }
}
</script>

<!-- <style scoped>
/* 精緻的滑動與陰影微動畫 */
.card {
  transition: all 0.2s ease-in-out;
}
.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08) !important;
}
</style> -->
